/* eslint-disable */
import awesomplete from 'awesomplete';
import 'awesomplete/awesomplete.css';
import getCursorXY from '@/assets/js/getCursorXY.js';
/* eslint-enable */

export default {
  data() {
    return {
      autoCompleteRef: 'awesomplete',
      backdropRef: 'backdrop',
      highlightsRef: 'highlights',
      isInput: false,
      input: {},
    };
  },
  mounted() {
    this.getAutocomplete();
  },
  computed: {
    highlitedText() {
      let vars = '';
      for (let i = 0; i < this.autocompleteList.length; i += 1) {
        vars += `(@${this.autocompleteList[i]})`;
        if (i + 1 !== this.autocompleteList.length) {
          vars += '|';
        }
      }
      const expression = new RegExp(`${vars}.*?\\b`, 'g');
      return this.text.replace(/\n$/g, '\n\n').replace(expression, '<mark>$&</mark>');
    },
  },
  methods: {
    getCaret(node) {
      if (node.selectionStart) {
        return node.selectionStart;
      } else if (!document.selection) {
        return 0;
      }

      const c = '\\001';
      const sel = document.selection.createRange();
      const dul = sel.duplicate();
      let len = 0;

      dul.moveToElementText(node);
      sel.text = c;
      len = dul.text.indexOf(c);
      sel.moveStart('character', -1);
      sel.text = '';
      return len;
    },
    getWord() { // eslint-disable-line
      const el = this.input;
      const caret = this.getCaret(el);
      const words = el.value.split(/\s+|\n|\r/);
      let x = 0;

      for (let i = 0; i < words.length; i += 1) {
        x += words[i].length + 1;
        if (x >= caret) {
          return words[i];
        }
      }

      return '';
    },
    avoidEmptyLines(event) {
      const lines = this.input.value.split('\n');
      const lastLineCharacters = lines[!lines.length ? 0 : lines.length - 1].length;
      if (lines.length === 0 || lastLineCharacters === 0) {
        event.preventDefault();
      }
    },
    getAutocomplete() {
      this.input = !this.isInput ? this.$refs[this.autoCompleteRef] : this.$refs[this.autoCompleteRef].$refs.input; // eslint-disable-line
      new awesomplete(this.input, { // eslint-disable-line
        list: this.autocompleteList,
        minChars: 1,
        autoFirst: true,
        // eslint-disable-next-line
        filter: (text) => {
          let match = '';
          const contains = String(this.getWord()).substr(0, 1) === '@' && String(this.getWord()).length === 1;
          if (!contains) {
            match = String(this.getWord().match(/@[a-zA-Z]+$/)).replace('@', '');
          }
          return awesomplete.FILTER_CONTAINS(text, match);
        },
        item: (text, input) => awesomplete.ITEM(text, String(input.match(/@[a-zA-Z]+$/)).replace('@', '')),
        replace: (text) => {
          const caretPosition = this.getCaret(this.input);
          const before = this.text.substr(0, caretPosition).match(/^[\s\S]*@\s*/);
          const after = this.text.substr(caretPosition, this.text.length).match(/^[\s\S]*@\s*/);
          this.text = String(`${before}@${text}${after ? after.input : ''}`).replace('@@', '@');
        },
      });

      this.input.addEventListener('awesomplete-open', () => {
        const position = getCursorXY(this.input, this.input.selectionEnd); // eslint-disable-line
        this.input.parentElement.getElementsByTagName('ul')[0].style.top = `${position.top > 160 ? 160 : position.top + 20}px`;
        this.input.parentElement.getElementsByTagName('ul')[0].style.left = `${position.left - 30}px`;
      });

      const backdrop = document.createElement('div');
      backdrop.className = 'backdrop';
      backdrop.setAttribute('id', this.backdropRef);
      const highlights = document.createElement('div');
      highlights.className = 'highlights';
      highlights.setAttribute('id', this.highlightsRef);
      backdrop.appendChild(highlights);
      this.input.parentElement.appendChild(backdrop);

      this.input.addEventListener('scroll', () => {
        const scroll = this.input.scrollTop;
        setTimeout(() => {
          document.getElementById(this.backdropRef).scrollTop = scroll;
        }, 0.5);
      });
    },
  },
  watch: {
    text(newVal) { // eslint-disable-line
      document.getElementById(this.highlightsRef).innerHTML = this.highlitedText;
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/autoComplete.js